module.exports = __webpack_public_path__ + "static/media/groupama.f1d06c1c.svg";